import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/SURVEYMANAGE') => `${reducer}/${actionType}`;

export const fetchAllList = (surType = null) => {
	return async (dispatch, getState) => {
		const { surveyType, fetchAll } = getState().organism.surveyManage;
		const { from, size } = fetchAll;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchAll', values: { $list: res.info.data ?? [], total: res.info.COUNT ?? 0 } },
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchAll', values: { $list: [] } },
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchAll', values: { _list: status } },
			});
		};

		if (surType === 'S' || surveyType === 'S')
			api.$suggestion_fetch_all({ onOK, onFail, onStatus }, { from: from, to: from + size - 1 });
		else if (surType === 'C' || surveyType === 'C')
			api.$complaint_fetch_all({ onOK, onFail, onStatus }, { from: from, to: from + size - 1 });
	};
};

export const showItem = () => {
	return async (dispatch, getState) => {
		const { showItem, surveyType } = getState().organism.surveyManage;
		const { selectedItem } = showItem;

		const onOK = async (res) => {
			await dispatch(fetchAllList());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'showItem', values: { _show: status } },
			});
		};

		if (surveyType === 'S') api.$suggestion_fetch_id({ onOK, onFail, onStatus }, { id: selectedItem.ID });
		else if (surveyType === 'C') api.$complaint_fetch_id({ onOK, onFail, onStatus }, { id: selectedItem.ID });
	};
};

export const deleteItem = () => {
	return async (dispatch, getState) => {
		const { deleteItem, surveyType } = getState().organism.surveyManage;
		const { selectedItem } = deleteItem;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'deleteItem', values: { selectedItem: null } },
			});
			await dispatch(fetchAllList());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'deleteItem', values: { _delete: status } },
			});
		};

		if (surveyType === 'S') api.$suggestion_delete({ onOK, onFail, onStatus }, { id: selectedItem.ID });
		else if (surveyType === 'C') api.$complaint_delete({ onOK, onFail, onStatus }, { id: selectedItem.ID });
	};
};
